<template>
  <div class="flex items-center mx-n2 my-4">
    <a
      v-if="t('youtube')"
      :href="t('youtube')"
      class="btn p-1 flex-grow-1 sm:flex-grow-0"
      target="_blank"
      rel="noreferrer"
      aria-label="youtube"
    >
      <i class="mi-you-tube icon-28" />
    </a>
    <a
      v-if="t('instagram')"
      :href="t('instagram')"
      class="btn p-1 flex-grow-1 sm:flex-grow-0"
      target="_blank"
      rel="noreferrer"
      aria-label="instagram"
    >
      <i class="mi-instagram icon-28" />
    </a>
    <a
      v-if="t('facebook')"
      :href="t('facebook')"
      class="btn p-1 flex-grow-1 sm:flex-grow-0"
      target="_blank"
      rel="noreferrer"
      aria-label="facebook"
    >
      <i class="mi-facebook icon-28" />
    </a>
    <a
      v-if="t('twitter')"
      :href="t('twitter')"
      class="btn p-1 flex-grow-1 sm:flex-grow-0"
      target="_blank"
      rel="noreferrer"
      aria-label="twitter"
    >
      <i class="mi-x-twitter icon-28" />
    </a>
    <a
      v-if="t('pinterest')"
      :href="t('pinterest')"
      class="btn p-1 flex-grow-1 sm:flex-grow-0"
      target="_blank"
      rel="noreferrer"
      aria-label="pinterest"
    >
      <i class="mi-pinterest icon-28" />
    </a>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<i18n>
  {
    "cs": {
    "facebook": "https://www.facebook.com/mixit.cz",
    "instagram": "https://instagram.com/mix.it",
    "pinterest": "https://www.pinterest.com/mixitcz/",
    "twitter": "https://twitter.com/#!/MIXITcz",
    "youtube": "https://www.youtube.com/user/MIXITCZ"
},
    "sk": {
    "facebook": "https://www.facebook.com/mixit.sk",
    "instagram": "https://instagram.com/mix.it",
    "pinterest": "https://in.pinterest.com/mixitsk/",
    "twitter": "https://twitter.com/#!/MIXITcz",
    "youtube": "https://www.youtube.com/channel/UC_XHgM3HQM8qNdiPKGjefCg"
},
    "pl": {
    "facebook": "https://www.facebook.com/mixitpl",
    "instagram": "https://www.instagram.com/mixit.pl/",
    "pinterest": "https://www.pinterest.com/mixitpl/",
    "twitter": "https://twitter.com/ #! /MixitPL",
    "youtube": "https://www.youtube.com/user/mixitpl"
},
    "hu": {
    "facebook": "https://www.facebook.com/mixit.Hungary/",
    "instagram": "https://www.instagram.com/mixit.hu",
    "pinterest": "https://www.pinterest.com/mixitcz/",
    "twitter": "https://twitter.com/#!/MIXITcz",
    "youtube": "https://www.youtube.com/{'@'}mixithu9453/featured "
},
    "de": {
    "facebook": "https://www.facebook.com/de.mixit",
    "instagram": "https://instagram.com/mixit.de",
    "pinterest": "https://www.pinterest.com/mixitde/",
    "twitter": "",
    "youtube": "https://www.youtube.com/{'@'}MIXITDE"
},
    "at": {
    "facebook": "https://www.facebook.com/de.mixit",
    "instagram": "https://instagram.com/mixit.de",
    "pinterest": "https://www.pinterest.com/mixitde/",
    "twitter": "",
    "youtube": "https://www.youtube.com/{'@'}MIXITDE"
},
    "ro": {
    "facebook": "https://www.facebook.com/mixit.ro/",
    "instagram": "https://www.instagram.com/mixit.romania/",
    "pinterest": "https://www.pinterest.com/mixitcz/",
    "twitter": "https://twitter.com/#!/MIXITcz",
    "youtube": "https://www.youtube.com/{'@'}mixitro6957/featured"
},
    "fr": {
    "facebook": "https://www.facebook.com/mixit.fr",
    "instagram": "https://instagram.com/mixit.fr",
    "pinterest": "https://www.pinterest.com/mixitcz/",
    "twitter": "https://twitter.com/ # ! /MixitCZ",
    "youtube": "https://www.youtube.com/user/MIXITCZ"
}
  }
</i18n>
